import React from 'react'
import { QAndAContentData } from '../FlyOutUsageMetering/RightSectionComponents/QAndASidePannel'

export const marketplaceCloudAccountFaqContent: QAndAContentData[] = [
  {
    question: 'Q1. What is the Cloud Accounts page?',
    answer:
      'The Cloud Accounts page allows you to connect your AWS, Microsoft Azure, and Google Cloud (GCP) accounts to the Labra platform. Once connected, Labra can securely access the data required for Marketplace, Co-sell, and Assessment workflows.',
  },
  {
    question: 'Q2. Can I connect more than one cloud account?',
    answer: (
      <ul
        style={{
          marginLeft: '-24px',
          marginTop: '4px',
        }}
      >
        <li>
          Yes. You can connect{' '}
          <span style={{ fontWeight: 500 }}>
            multiple accounts for each cloud provider
          </span>{' '}
          (AWS, Microsoft Azure, and GCP).
        </li>
        <li>
          Each connected account is managed separately, and you can switch
          between environments anytime.
        </li>
      </ul>
    ),
  },
  {
    question: 'Q3. How do I add a new cloud account?',
    answer: (
      <ol
        style={{
          marginLeft: '-24px',
          marginTop: '4px',
        }}
      >
        <li>
          Click <span style={{ fontWeight: 500 }}>Add new cloud account</span>.
        </li>
        <li>
          Select the cloud hyperscaler you want to connect (AWS, Microsoft, or
          GCP).
        </li>
        <li>
          You will be directed to a setup screen for that cloud hyperscaler.
        </li>
        <li>Follow the instructions to complete the connection.</li>
      </ol>
    ),
  },
  {
    question: 'Q4. Why do I need to provide a unique cloud account name?',
    answer:
      'A unique name helps you easily identify each connected account—especially when managing multiple AWS, Microsoft, or GCP accounts.',
  },
  {
    question:
      'Q5. What permissions are required for each cloud provider, and who in your organization can help with the setup?',
    answer: (
      <>
        <span style={{ fontWeight: 500 }}>AWS:</span>
        <ul
          style={{
            marginLeft: '-24px',
            marginTop: '2px',
          }}
        >
          <li>An AWS Admin will need to deploy the CloudFormation template.</li>
          <li>
            Labra requires permission to create AWS resources during setup,
            which only an AWS Admin can authorize.
          </li>
        </ul>
        <span style={{ fontWeight: 500 }}>Microsoft Azure:</span>
        <ul
          style={{
            marginLeft: '-24px',
            marginTop: '2px',
          }}
        >
          <li>Requires Global Admin approval.</li>
          <li>
            You will need your organization's global admin Access to complete
            the connection setup successfully.
          </li>
        </ul>
        <span style={{ fontWeight: 500 }}>GCP:</span>
        <ul
          style={{
            marginLeft: '-24px',
            marginTop: '2px',
          }}
        >
          <li>Requires GCP Portal Admin permissions.</li>
          <li>
            Admin authorization is needed to establish a secure connection with
            the Labra platform.
          </li>
        </ul>
      </>
    ),
  },
  {
    question: 'Q6. Can I edit cloud account details later?',
    answer:
      'Yes. You can update or modify the configuration of any connected cloud account at any time.',
  },
  {
    question: 'Q7. What if my setup fails?',
    answer:
      'Please follow the instructions, and if anything is unclear, feel free to reach out to our support team.',
  },
]
